import { lazy } from 'react';
import type { RouteConfig } from './types';
import { ComponentSuspense } from '@/components/ui/suspense-wrapper';

const LoginPage = lazy(() => import('@/pages/auth/login'));
const RegisterPage = lazy(() => import('@/pages/auth/register'));
const VerifyEmailPage = lazy(() => import('@/pages/auth/verify-email'));
const RecoverPasswordPage = lazy(() => import('@/pages/auth/recover-password'));
const AcceptInvitationPage = lazy(() => import('@/pages/auth/accept-invitation'));
const GoogleRedirectPage = lazy(() => import('@/pages/auth/google-redirect'));
const GoogleSuccessPage = lazy(() => import('@/pages/auth/google-success'));

export const authRoutes: RouteConfig[] = [
  {
    path: "/auth/login",
    element: (
      <ComponentSuspense >
        <LoginPage />
      </ComponentSuspense>
    ),
    meta: {
      title: "UzaForm | Login",
      description: "Login to your uzaform account"
    }
  },
  {
    path: "/auth/register", 
    element: (
      <ComponentSuspense >
        <RegisterPage />
      </ComponentSuspense>
    ),
    meta: {
      title: "UzaForm | Register",
      description: "Create a new uzaform account"
    }
  },
  {
    path: "/auth/forgot-password",
    element: (
      <ComponentSuspense >
        <RecoverPasswordPage />
      </ComponentSuspense>
    ),
    meta: {
      title: "UzaForm | Forgot Password",
      description: "Reset your uzaform password"
    }
  },
  {
    path: "/auth/verify-email",
    element: (
      <ComponentSuspense >
        <VerifyEmailPage />
      </ComponentSuspense>
    ),
    meta: {
      title: "UzaForm | Verify Email",
      description: "Verify your uzaform email"
    }
  },
  {
    path: "/auth/accept-invitation",
    element: (
      <ComponentSuspense >
        <AcceptInvitationPage />
      </ComponentSuspense>
    ),
    meta: {
      title: "UzaForm | Accept Invitation",
      description: "Accept company invitation"
    }
  },
  {
    path: "/auth/google",
    element: (
      <ComponentSuspense>
        <GoogleRedirectPage />
      </ComponentSuspense>
    ),
    meta: {
      title: "Google Authentication | UzaForm",
      description: "Redirecting to Google authentication",
      requiresAuth: false,
    }
  },
  {
    path: "/auth/google-success",
    element: (
      <ComponentSuspense>
        <GoogleSuccessPage />
      </ComponentSuspense>
    ),
    meta: {
      title: "Google Authentication Success | UzaForm",
      description: "Google authentication successful",
      requiresAuth: false,
    }
  }
];
